import { useLocation, useNavigate } from "react-router-dom";
import Menu, { MenuItem } from "../../menu/Menu";
import { LogoDescription, LogoText, LogoTextEm, LogoWrapper, MainSideBarWrapper, MenuGroup, MenuGroupContent, MenuGroupTitle, MenuItemText, MenuItemWrapper, MenuWrapper } from "./MainSideBar.styled";
import ViewStateService from "../../../../services/view-state/ViewStateService";
import SessionService from "../../../../services/session/SessionService";

interface MainSideBarProps {

}

const MainSideBar: React.FC<MainSideBarProps> = (props)=> {
    let menu = Menu.getMainMenu();
    let location = useLocation();
    let navigate = useNavigate();

    let profile = SessionService.getInstance().getCurrentUserProfile();
    if (!profile.admin) {
        menu.groups = [];
    };

    let onMenuItemClick = (menuItem: MenuItem)=> {
        navigate(menuItem.path);
        ViewStateService.getInstance().setStatusBarTitle(menuItem.name);
    }

    let isSelected = (menuItem: MenuItem)=> {
        let pathname = location.pathname;
        if (pathname.startsWith(menuItem.path)) {
            ViewStateService.getInstance().setStatusBarTitle(menuItem.name);
            return true;
        }
        return false;
    }

    return (
        <MainSideBarWrapper>
            <LogoWrapper>
                <LogoText><LogoTextEm>W</LogoTextEm>inch <LogoTextEm>T</LogoTextEm>enant <LogoTextEm>A</LogoTextEm>dmin</LogoText>
                <LogoDescription>智能卷扬机租户管理系统</LogoDescription>
            </LogoWrapper>

            <MenuWrapper>
                {
                    menu.groups.map((menuGroup)=> {
                        return (
                            <MenuGroup key={menuGroup.name}>
                                <MenuGroupTitle>{menuGroup.name}</MenuGroupTitle>
                                <MenuGroupContent>
                                    {
                                        menuGroup.items.map((menuItem)=> {
                                            return (
                                                <MenuItemWrapper key={menuItem.path} className={isSelected(menuItem) ? "active": ""} onClick={()=> onMenuItemClick(menuItem)}>
                                                    <MenuItemText>{menuItem.name}</MenuItemText>
                                                </MenuItemWrapper>
                                            )
                                        })
                                    }
                                </MenuGroupContent>
                            </MenuGroup>
                        )
                    })
                }
            </MenuWrapper>

        </MainSideBarWrapper>
    )
}

export default MainSideBar;

